module.exports = __webpack_public_path__ + "img/team-member-03.398bb406.jpg";